import React, { useEffect, useState } from "react";
import { render, unmount } from 'rc-util/lib/React/render';
import RiskVerify from "@/components/RiskVerify";
import Modal from 'react-modal';

function Home(): JSX.Element {
  const handleSelect = () => {}
  const handleCancel = () => {}

  useEffect(() => {
    new RiskVerify().verify({
      sessionId: "dddd",
      title: "string",
      subTitle: "string",
      isUseList: false,
      verifyList: []
    })

  }, [])
  return (
    <h1></h1>
  );
}

export default Home;
